import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideRequestType extends AbstractModel {
  @autoserialize
  code: string;

  @autoserialize
  name: string;

  @autoserialize
  description: string;

  @autoserialize
  onDemand: boolean;
}
